<template>
  <IDEDialog
    title="新建文件"
    width="400px"
    :visible="visible"
    @confirm="confirm"
    @close="close"
  >
    <el-form ref="form" :model="form">
      <el-form-item prop="name">
        <InputItem label="目录名称" :required="true">
          <el-input v-model="form.name" placeholder="请输入目录名称"/>
        </InputItem>
      </el-form-item>
      <el-form-item prop="cycle">
        <InputItem label="构建周期" :required="true">
          <el-select v-model="form.cycle">
            <el-option label="一次性构建" value="ONCE"/>
            <el-option label="模块构建" value="MODULE"/>
          </el-select>
        </InputItem>
      </el-form-item>
      <el-form-item prop="enableExp">
        <InputItem label="启用逻辑">
          <el-input type="textarea" v-model="form.enableExp" placeholder="表达式返回true字符串表示启用"/>
        </InputItem>
      </el-form-item>
    </el-form>
  </IDEDialog>
</template>

<script>
import IDEDialog from '../IDEDialog'
import InputItem from './InputItem'
export default {
  name: 'OperaFolderDialog',
  components: { InputItem, IDEDialog },
  data () {
    return {
      visible: false,
      folder: null,
      parentFolder: null,
      form: {
        name: '',
        enableExp: '',
        cycle: 'ONCE',
        path: ''
      }
    }
  },
  methods: {
    // 打开窗口
    open (folder, parentFolder) {
      this.visible = true
      this.folder = folder
      this.parentFolder = parentFolder
      // 编辑
      if (folder != null) {
        this.$nextTick(() => {
          for (const key in this.form) {
            this.form[key] = folder[key]
          }
          this.form.cycle = parentFolder.cycle
          this.form.path = parentFolder.path
        })
      }
      // 新建
      if (folder == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form.cycle = parentFolder.cycle
          this.form.path = parentFolder.path
        })
      }
    },
    // 关闭窗口
    close () {
      this.visible = false
    },
    // 确认
    confirm () {
      this.form.path = this.form.path + '/' + this.form.name
      // 新建
      if (this.folder == null) {
        this.$emit('create-success', { folder: this.form, parentFolder: this.parentFolder })
      }
      // 编辑
      if (this.folder != null) {
        Object.assign(this.folder, this.form)
        this.$emit('edit-success', { folder: this.folder, parentFolder: this.parentFolder })
      }
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
